import { atom } from "jotai";

export const selectedObjectAtom = atom<string | null>(null);
